const loadChatView = () => import(/* webpackChunkName: "view-chat" */ '../view/Chat');
const loadFriendView = () => import(/* webpackChunkName: "view-friend" */ '../view/Friend');
const loadGroupView = () => import(/* webpackChunkName: "view-group" */ '../view/Group');

let chatViewPreloadPromise = null;
let friendViewPreloadPromise = null;
let groupViewPreloadPromise = null;

export function loadChatRouteView() {
	return loadChatView();
}

export function preloadChatRouteView() {
	if (!chatViewPreloadPromise) {
		chatViewPreloadPromise = loadChatView().catch((error) => {
			chatViewPreloadPromise = null;
			throw error;
		});
	}
	return chatViewPreloadPromise;
}

export function loadFriendRouteView() {
	return loadFriendView();
}

export function preloadFriendRouteView() {
	if (!friendViewPreloadPromise) {
		friendViewPreloadPromise = loadFriendView().catch((error) => {
			friendViewPreloadPromise = null;
			throw error;
		});
	}
	return friendViewPreloadPromise;
}

export function loadGroupRouteView() {
	return loadGroupView();
}

export function preloadGroupRouteView() {
	if (!groupViewPreloadPromise) {
		groupViewPreloadPromise = loadGroupView().catch((error) => {
			groupViewPreloadPromise = null;
			throw error;
		});
	}
	return groupViewPreloadPromise;
}

export function preloadWorkspaceRouteViews() {
	return Promise.allSettled([
		preloadChatRouteView(),
		preloadFriendRouteView(),
		preloadGroupRouteView()
	]);
}
